import {
  UPLOAD_XML_ZIP_FILE,
  UPLOAD_XML_ZIP_FILE_SUCCESS,
  UPLOAD_XML_ZIP_FILE_FAILED,
  UPLOAD_XML_ZIP_FILE_NOTIFIED,
  UPLOAD_XML_ZIP_FILE_RESET,
} from "../action/actionType";

const initialState = {
  loading: false,
  data: null,
  error: null,
  status: false,
};

export const uploadXmlZipFileReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPLOAD_XML_ZIP_FILE:
      return {
        ...state,
        loading: true,
      };
    case UPLOAD_XML_ZIP_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
        error: null,
        status: true,
      };
    case UPLOAD_XML_ZIP_FILE_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: payload,
        status: false,
      };
    case UPLOAD_XML_ZIP_FILE_RESET:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
        status: false,
      };
    case UPLOAD_XML_ZIP_FILE_NOTIFIED:
      return {
        ...state,
        notified: true,
      };
    default:
      return state;
  }
};

